import { Component, OnInit ,ViewChild} from '@angular/core';
import { PaymentService } from '../../../../service/payment-service';
import { TreeTable } from 'primeng/treetable';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import { PaymentSearchDTO } from '../../../../models/paymentSearchDTO';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-view-payment',
  templateUrl: './view-payment.component.html',
  styleUrl: './view-payment.component.scss'
})
export class ViewPaymentComponent implements OnInit  {

  @ViewChild('tt') tt?: TreeTable;

  cols!: Column[];
  getPaymentList!: any[];
  limit:number=10;
  currentPage:number=1
  totalRecords:number=0
  isLoading: boolean = false;
  paymentSearchDTO?:PaymentSearchDTO
  constructor(
    private paymentService:PaymentService
  ) {
    this.paymentSearchDTO= new PaymentSearchDTO()
  }

  ngOnInit(): void {

    this.cols = [
      { field: 'vendor_code', header: 'Vendor Code' },
      { field: 'invoice_no', header: 'Invoice No' },
      { field: 'document_date', header: 'Invoice Date' },
      { field: 'miro_no', header: 'Miro No' },
      { field: 'payment_document_no', header: 'Payment Document No' },
      { field: 'posting_date', header: 'Posting Date' },
      { field: 'amount', header: 'Payment Amount' },
      { field: 'invoice_amount', header: 'Invoice Amount' },
      { field: 'balance_amount', header: 'Balance Amount' },
      { field: 'clearing_document_no', header: 'Clearing Document No' },
      { field: 'purchase_order_no', header: 'PO/Agreement No' },
      { field: 'description', header: 'Description' },
      { field: 'utr_no', header: 'UTR No'}
  ];
  this.get_payment_list()

  }

  get_payment_list(){
    let data={
      page:this.currentPage,
      limit:this.limit,
      payment_search_dto:this.paymentSearchDTO
      }
    this.isLoading=true
    this.paymentService.getPaymentLists(data).then((response)=>{
      this.isLoading=false
      this.getPaymentList = response.message.payment_list
      this.totalRecords = response.message.total_payment

    }).catch((error)=>{
      this.isLoading=false
      console.log(error)
    })
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.get_payment_list()
  }

  onInputChange(event: any, field: string) {
    const inputValue = (event.target as HTMLInputElement)?.value;
    if (this.paymentSearchDTO && field) {
      (this.paymentSearchDTO as any)[field] = inputValue;
    }
    this.currentPage=1
    this.get_payment_list()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  downloadExcel(){
    const formattedData = this.formatDataForExcel(this.getPaymentList);
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const colWidths = this.calculateColumnWidths(formattedData);

    // Set the column widths
    ws['!cols'] = colWidths.map(width => ({ wch: width }));
    XLSX.utils.book_append_sheet(wb, ws, 'PaymentList');
    XLSX.writeFile(wb, 'Payment List.xlsx');
  }

  formatDataForExcel(data: any[]): any[] {

    const formattedData = data.map(payment => ({
      'Document Date': payment.document_date,
      'Vendor Code': payment.vendor_code,
      'Purchase Order No':payment.purchase_order_no,
      'Posting Date':payment.posting_date,
      'Invoice No':payment.invoice_no,
      'MIRO NO':payment.miro_no,
      'Payment Amount':payment.amount,
      'Invoice Amount':payment.invoice_amount,
      'Balance Amount':payment.balance_amount,
      'Payment Document No':payment.payment_document_no,
      'Clearing Document No':payment.clearing_document_no,
      'Description':payment.description,
      'UTR No':payment.utr_no
    }));
    return formattedData;
  }

  calculateColumnWidths(data: any[]): number[] {
    const colWidths: number[] = [];
    const keys = Object.keys(data[0]);

    keys.forEach((key, colIndex) => {
        let maxWidth = key.length;
        data.forEach(row => {
            maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
        });
        colWidths[colIndex] = maxWidth + 2;
    });

    return colWidths;
  }

  downloadPDF() {
    let startY = 75;
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default('p', 'pt');

        const rowCount1 = this.getPaymentList.length;
        const lineHeight = 12;
        const tableHeight1 = rowCount1 * lineHeight * 200;
        // startY += tableHeight1 + 400;


        autoTable(doc, {
          head: [['Document Date', 'Vendor Code', 'Purchase Order No', 'Posting Date', 'Invoice No', 'MIRO NO','Amount','Payment Document No','Clearing Document No']],
          body: this.getPaymentList.map(row => this.cols.map(col => row[col.field])),
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 3, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1;
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height
              };
            }
          }
        });
        doc.save('Payment List.pdf');
      });
    });
  }

}
